import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldX, CheckCircle2, XCircle } from 'lucide-react';
export function Layer3EligibilityGates() {
  const gates = [{
    rule: 'Min PSP tenure',
    threshold: '≥ 6 months live',
    rationale: 'Insufficient history below this for reliable modelling',
    pass: true
  }, {
    rule: 'Min 3mo avg GMV',
    threshold: 'Above product floor (e.g. SGD 10,000/mo)',
    rationale: 'Ensures loan is repayable from MDR revenue',
    pass: true
  }, {
    rule: 'Max chargeback rate',
    threshold: '< 1.0% last 90 days',
    rationale: 'Elevated CB signals fraud risk or business quality issues',
    pass: true
  }, {
    rule: 'Min active trading days',
    threshold: '≥ 15 days/month',
    rationale: 'Rules out dormant or near-inactive accounts',
    pass: true
  }, {
    rule: 'Settlement holds',
    threshold: 'Zero active holds',
    rationale: 'Any hold flag indicates compliance or fraud investigation',
    pass: true
  }, {
    rule: 'Negative trend gate',
    threshold: 'Not > −40% MoM for 2+ consecutive months',
    rationale: 'Protects against lending into terminal decline',
    pass: true
  }];
  return <SectionWrapper title="Layer 3: Eligibility Gates (Hard Rules)" subtitle="Before any scoring occurs, applicants must pass binary hard rules. Failure on any single gate results in an immediate decline with no scoring." data-id="element-255">
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden mb-8" data-id="element-256">
        <div className="overflow-x-auto" data-id="element-257">
          <table className="w-full text-sm text-left" data-id="element-258">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-259">
              <tr data-id="element-260">
                <th className="px-6 py-4" data-id="element-261">Rule</th>
                <th className="px-6 py-4" data-id="element-262">Threshold</th>
                <th className="px-6 py-4" data-id="element-263">Rationale</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-264">
              {gates.map((gate, i) => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-265">
                  <td className="px-6 py-4 font-medium text-slate-900 flex items-center gap-2" data-id="element-266">
                    <CheckCircle2 className="w-4 h-4 text-teal-500" data-id="element-267" />
                    {gate.rule}
                  </td>
                  <td className="px-6 py-4 font-mono text-xs text-indigo-600 bg-indigo-50/50" data-id="element-268">
                    {gate.threshold}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-269">{gate.rationale}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-red-50 rounded-xl border border-red-200 p-6 md:p-8 relative overflow-hidden" data-id="element-270">
        <div className="absolute top-0 right-0 p-8 opacity-10" data-id="element-271">
          <ShieldX className="w-32 h-32 text-red-600" data-id="element-272" />
        </div>
        <div className="relative z-10" data-id="element-273">
          <div className="flex items-center gap-3 mb-4" data-id="element-274">
            <div className="bg-red-100 p-2 rounded-lg" data-id="element-275">
              <XCircle className="w-6 h-6 text-red-600" data-id="element-276" />
            </div>
            <h3 className="text-xl font-bold text-red-900" data-id="element-277">
              Example: Declined Merchant
            </h3>
          </div>
          <p className="text-red-800 leading-relaxed max-w-2xl" data-id="element-278">
            A hawker stall processing{' '}
            <strong className="font-semibold" data-id="element-279">SGD 8,000/month</strong> with a{' '}
            <strong className="font-semibold" data-id="element-280">2.1% chargeback rate</strong>{' '}
            fails two gates simultaneously:
          </p>
          <ul className="mt-4 space-y-2" data-id="element-281">
            <li className="flex items-center gap-2 text-red-700 font-medium" data-id="element-282">
              <XCircle className="w-4 h-4" data-id="element-283" /> GMV below minimum threshold (SGD
              10,000)
            </li>
            <li className="flex items-center gap-2 text-red-700 font-medium" data-id="element-284">
              <XCircle className="w-4 h-4" data-id="element-285" /> CB rate above 1.0%
            </li>
          </ul>
          <div className="mt-6 inline-block bg-red-600 text-white text-sm font-bold px-4 py-2 rounded-lg shadow-sm" data-id="element-286">
            Application declined — No scoring proceeds
          </div>
        </div>
      </div>
    </SectionWrapper>;
}